import React, { Component } from "react";
import OffersList from "./OffersList";
import Footer from "./Footer";
import "./styles/Offers.scss";

class Offers extends Component {
  state = {};

  render() {
    return (
      <section id="main-content" className="animated fadeInUp">
        <div className="row">
          <div className="col-sm-12">
            <section id="offers-section">
              <OffersList />
            </section>
            <Footer />
          </div>
        </div>
      </section>
    );
  }
}

export default Offers;
